import { render, staticRenderFns } from "./CookieStatement.vue?vue&type=template&id=7d0ef16e&scoped=true"
import script from "./CookieStatement.vue?vue&type=script&lang=js"
export * from "./CookieStatement.vue?vue&type=script&lang=js"
import style0 from "./CookieStatement.vue?vue&type=style&index=0&id=7d0ef16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@6.11.0_webpack@5.99.9__lodash@4._400fd893165f8898ec34f2f453564d40/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ef16e",
  null
  
)

export default component.exports